import { AutoFormFieldProps } from "@autoform/react";
import CustomInputField from "@components/FormFields/CustomInputField"
import React from "react";

export const NumberField: React.FC<AutoFormFieldProps> = ({
  inputProps,
  error,
  id,
}) => {
  const { key, ...props } = inputProps;

  return (
    <CustomInputField
      id={id}
      type="number"
      className={error ? "border-destructive" : ""}
      {...props}
    />
  );
};
